import React from 'react';
import Sorting from './Sorting';
import '../css/regokas.css';
import _ from 'lodash';
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AiOutlinePlus } from "react-icons/ai";
import Loader from '../components/loader';
import Add from '../images/headericon/Add.svg';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Minus from '../images/Minus.svg';
import Plus from '../images/Plus.svg';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import checkIp from 'check-ip';
import { TextField } from '@mui/material';
import Edit from '../images/headericon/Edit.svg';
import ProjectDetailGray from '../images/sidebar/ProjectDetailGray.svg';
import downloadActive from '../images/headericon/downloadActive.svg';
import downloadUnactive from '../images/headericon/downloadUnactive.svg';
import SearchBar from './SearchBar';
import mc from '../images/mc.svg';
import ab from '../images/ab.svg';
import uvodb from '../images/uvodb.svg';
import vodb from '../images/vodb.svg';
import ml from '../images/ml.svg';
import Style from 'style-it';
import SnackBar from './../containers/SnackBar';
import { Box } from '@mui/system';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
} from "@mui/material";
import { is_allowed } from '../utils';

class ProjectDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: [],
            boxesForConfig: [],
            showmodels1ML: false,
            showmodels: '',
            showmodels2: '',
            showmodels1: '',
            showmodels6: '',
            currentBuildingSelected: '',
            kk: 'asdvhj',
            namess: '',
            projectName: [],
            status: [],
            sortedType: '',
            searchValue: '',
            actualdata: [],
            userType: [],
            actualdata1: [],
            si_name: '',
            statedata: '',
            hidebutton: true,
            rowOpenNumber: '',
            showRow: false,
            okasBoxDatalist: [],
            totbox: [],
            okasboxmodaletype: '',
            someNewOne: '',
            textvalue: [],
            okasbox1: [],
            siData: [],
            si_id: '',
            realtimebuildingid: '',
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            usertype: this.props.redux.globalVar.userTypeStyle,
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            currentConfigType: '',
            selectedSi: null,
            si_id: null,
            emailId: null,
            responseMessage: '',
            pmId: null,
            projectManager: null,
            buildingId: [],
            buildingName: null,
            currentBoxSelected: '',
            currentProjectBoxDetails: [],
            ipError: false,
            subnetError: false,

            defaultError: false,
            showError: false,
            countForBoxAssign: 0,
            okasboxid: '',
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            ipaddress: '',
            subnetmask: '',
            defaultgateway: '',
            projectDetailMobileView: false,
            snackbarActive: false,
            snackbarMessage: '',


        };
        this.handleClickpage = this.handleClickpage.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }




    componentWillMount() {
        this.checkuserApi();
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                })
            }
                .bind(this),
            3000
        );


    }


    checkuserApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {
                // checkuserApidata = {
                //     "first_name": "OKAS Training",
                //     "User_Type": "3",
                //     "user_name": "training@vyom.ai",
                //     "status": "200"
                // }
                this.setState({
                    checkuserApidata,
                    actualdata: checkuserApidata,
                    userType: checkuserApidata.User_Type,
                }, () => {
                    // this.props.userNameStyleActivate(this.state.checkuserApidata.user_name)
                    // this.props.reuserNameStyleActivate(this.state.checkuserApidata.first_name)
                    // this.props.userTypeStyleActivate(this.state.checkuserApidata.User_Type) 
                    // console.log(this.state.userType)
                    if (this.state.checkuserApidata.status !== '200') {
                        localStorage.removeItem('auth');
                        // alert('invalid authentication found');
                        // this.props.history.push('/login') 
                        window.location = "/login";
                    } else {

                    }
                })
            })
    }





    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }
    ////------------------------------------------------ Delete Succ msg end//------------------------------------------------




    handleChange(e) {
        //console.log(e.target.checked)
        //console.log(e.target.name)
        let oldArray = this.state.textvalue;
        let current = e.target.value;
        if (e.target.checked == true) {
            oldArray.includes(current) ? oldArray.pop(current) : oldArray.push(current);
            if (!oldArray.includes(current)) {
                this.setState({
                    textvalue: oldArray
                })

            }
        } else {
            oldArray = _.pull(oldArray, current);
            if (!oldArray.includes(current)) {
                this.setState({
                    textvalue: oldArray
                })
            }

        }
        this.setState({
            okasboxid: this.state.textvalue.join(),
        });

    }



    updateConfigIP = (buttonaction, pmids) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        let ipaddress = this.state.ipaddress;
        let subnetmask = this.state.subnetmask;
        let defaultgateway = this.state.defaultgateway;
        var ipError = checkIp(ipaddress);
        var subnetError = checkIp(subnetmask);
        var defaultError = checkIp(defaultgateway);
        let ip = ipaddress;
        let subnet_mask = subnetmask;
        let gateway = defaultgateway;
        let tt = {
            ip,
            subnet_mask,
            gateway,
        };

        if (ipError.isValid &&
            subnetError.isValid &&
            defaultError.isValid &&
            ipaddress !== '0.0.0.0' &&
            subnetmask !== '0.0.0.0' &&
            defaultgateway !== '0.0.0.0'
        ) {
            fetch('/we/we/okasBox_detail/' + pmids, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(data => {
                    // console.log(data)
                    if (data.status == 200) {
                        // alert('Box configured successfully');
                        this.setState({
                            snackbarMessage: 'Box configured successfully.',
                            snackbarActive: true,
                        })
                        // const history = createHistory({forceRefresh: true});  
                        // history.push('/projectdetail');   
                        this.getokasboxtabledata();
                        this.setState({
                            showmodels: false,
                        })
                    } else if (data.status == 400) {
                        // alert('IP has already given, please check');
                        this.setState({
                            snackbarMessage: 'IP has already given, please check.',
                            snackbarActive: true,
                        })
                    } else {

                        // alert('Action not completed.'); 
                        this.checkuserApi();
                    }
                }
                )
        } else {
            this.setState({
                ipError: ipError.isValid,
                subnetError: subnetError.isValid,
                defaultError: defaultError.isValid,
                showError: true
            })
            if (this.state.ipaddress === '0.0.0.0') {
                this.setState({
                    ipError: false
                })
            }
            if (this.state.subnetmask === '0.0.0.0') {
                this.setState({
                    subnetError: false
                })
            }
            if (this.state.defaultgateway === '0.0.0.0') {
                this.setState({
                    defaultError: false
                })
            }

        }

    }


    filterLastMonthData(data) {
        // Get the current date and set to the first day of the current month
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        // Determine the last month and its year
        const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

        // Start and end dates for the last month
        const startOfLastMonth = new Date(lastMonthYear, lastMonth, 1);
        const endOfLastMonth = new Date(lastMonthYear, lastMonth + 1, 0, 23, 59, 59);

        // Filter the data by assigned_at date within last month
        return data.filter(item => {
            const assignedDate = new Date(item.modified);
            return assignedDate >= startOfLastMonth && assignedDate <= endOfLastMonth;
        });
    }


    componentDidMount() {
        this.getallrealdata();
        // this.setState({
        //     loader: true,
        // })

        // let TokenValue = 'Token ' + localStorage.getItem("auth");
        // var headers = {
        //     'Content-Type': 'application/json',
        //     'Authorization': TokenValue
        // }
        // fetch('/we/we/projectBuildingApi/', {
        //     method: "GET",
        //     headers: headers
        // })
        //     .then(response => response.json())
        //     .then(okasBoxData => {
        //         const params = new URLSearchParams(window.location.search)
        //         const filter = params.get("filter")
        //         //     console.log(okasBoxData)
        //         //     this.setState({
        //         //         okasBoxData,
        //         //         actualdata1: okasBoxData
        //         //     }, () => {
        //         //         this.renderTableData();
        //         //         // console.log('projectBuildingApi:',this.state.actualdata1);  // console turned on 
        //         //     })
        //         //     this.setState({
        //         //         loader: false,
        //         //     })
        //         // })
        //         if (filter === "lastMonth") {

        //             this.setState({
        //                 okasBoxData: this.filterLastMonthData(okasBoxData),
        //                 actualdata: this.filterLastMonthData(okasBoxData)
        //             }, () => {
        //                 this.renderTableData();
        //                 // console.log(this.state.okasInventoryData)
        //             })
        //         } else {
        //             // okasBoxData = okasBoxData.slice(0,10)
        //             this.setState({
        //                 okasBoxData,
        //                 actualdata: okasBoxData
        //             }, () => {
        //                 this.renderTableData();
        //                 // console.log(this.state.okasInventoryData)
        //             })

        //         }
        //     })



        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/projectBuildingApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {

                this.setState({
                    okasBoxData,
                    actualdata1: okasBoxData
                }, () => {
                    this.renderTableData();

                })
                this.setState({
                    loader: false,
                })
            })




        fetch('/we/we/okastabledata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxDatalist => {
                this.setState({
                    okasBoxDatalist
                }, () => {
                    // this.getokasnumber();
                    // console.log('okasData Table:',this.state.okasBoxDatalist)
                })
            })
    }

    ///////////////////////// SI data start////////////////////
    getallrealdata = (building_id) => {
        // console.log(building_id)
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        const url = building_id
            ? `/we/we/projectManagerApi/?building_id=${building_id}`
            : `/we/we/projectManagerApi/`;

        fetch(url, {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                this.setState({
                    siData,
                    actualdata: siData,

                }, () => {
                    this.renderTableData();
                    // console.log('sitest', this.state.actualdata)
                    // console.log('Building ID used in fetch:', building_id);
                })
                this.setState({
                    loader: false,
                })
            })
    }
    //////////////// SI data end////////////////
    // MasterController


    getokasboxtabledata = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/projectBuildingApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {


                this.setState({
                    okasBoxData,
                    actualdata: okasBoxData
                }, () => {
                    this.renderTableData();
                    // console.log('getokasboxtabledata:', this.state.okasBoxData);
                })
                this.setState({
                    loader: false,
                })
            })





        fetch('/we/we/okastabledata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxDatalist => {
                this.setState({
                    okasBoxDatalist
                }, () => {
                    // this.getokasnumber();
                    // console.log('gt',this.state.okasBoxDatalist)
                })
            })
    }

    getokaslist = (okasboxtype, buildingid, okasboxtypetoget) => {

        // console.log(okasboxtypetoget)
        var typee = 0;
        let count = 0;
        let xx = this.state.okasBoxDatalist.map((x, index) => {
            if (x.okasBox_type === okasboxtype && x.okasBox_assigned_to === 'unassigned') {
                typee = typee + 1;
                count++
                return (
                    <tr key={index}>
                        <input type="hidden" value={buildingid} />
                        <input type="hidden" value={okasboxtypetoget} />
                        <td style={{ paddingLeft: '5%' }}><input type="checkbox" name={x.okasBox_type}
                            onChange={
                                this.handleChange
                            }
                            value={x.okasBox_id} /></td>
                        {/* <td style={{paddingLeft: '5%'}}>{x.okasBox_id}</td>  */}
                        <td>{x.okasBox_type}</td>
                        <td>{x.okasBox_serialNo}</td>

                    </tr>
                )
            }
        });

        // console.log(count)
        this.setState({
            okasboxmodaletype: okasboxtype
        })
        if (count === 0) {
            this.setState({
                someNewOne: (<tr >
                    <td colSpan='4' className="text-center">
                        No box available
                    </td>
                </tr>),
                countForBoxAssign: count
            })
        } else {
            this.setState({
                someNewOne: xx,
                countForBoxAssign: count
            })
        }
        this.setState({
            realtimebuildingid: buildingid
        })
        this.setState({
            realtimeokasboxtypetoget: okasboxtypetoget
        })
        return xx;
    }



    getokasnumber = (okasboxtypetoget, buildingid) => {
        var typee = 0;
        let totbox1 = 0;
        let totbox2 = 0;
        let totbox3 = 0;
        let totbox4 = 0;
        let totbox5 = 0;
        let totbox6 = 0;
        let totbox7 = 0;

        let currentBuildingData = this.state.okasBoxData.filter((e) => e.building_id === buildingid)
        // console.log(currentBuildingData, this.state.okasBoxData)
        let xx = this.state.okasBoxDatalist.map((e, index) => {
           // console.log(e.okasBox_type);
            let test = _.split(okasboxtypetoget, ',');
            // console.log(this.state.okasBoxData)
            for (let i = 0; i < test.length; i++) {
                if (test[i] == e.okasBox_id) {
                    if (e.okasBox_type === 'Master Controller') {
                        totbox1++;
                    }
                    if (e.okasBox_type === 'VOD Box') {
                        totbox2++;
                    }
                    if (e.okasBox_type === 'UVOD Box Box') {
                        totbox3++;
                    }
                    if (e.okasBox_type === 'Audio Box') {
                        totbox4++;
                    }
                    if (e.okasBox_type === 'Control Studio') {
                        totbox6++;
                    }
                    // if (e.okasBox_type === 'Home Theatre Box') {
                    //     totbox5++;
                    // }
                    if (e.okasBox_type === 'Core Okas') {
                        totbox7++;
                    }
                }
                // console.log(totbox7)

            }
        });
        // return (

        //     <span>

        //         {totbox1 > 0  || totbox7 > 0  ?
        //             <span>
        //                 <span>
        //                     <div className="">
        //                         {/* <Icon icon={hddO} size={20} /> */}
        //                         <span className="icon-box-detail"><img src={mc} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('Master Controller') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Master Controller', showmodels1: true }) }}>
        //                             Master Studio({this.getCountOfBoxType('Master Controller')})
        //                         </a>
        //                         {/* <a  className="button" style={{marginRight: '15%', float: 'right' }}  data-toggle="modal" data-target="#hometheaterbox" onClick={(e)=>{this.getokaslist('Master Controller',buildingid,okasboxtypetoget)}} > {this.props.redux.globalVar.userTypeStyle==='2' ? '' :   <b><img src={Add}/></b>}</a> */}
        //                     </div>
        //                 </span>
        //                 <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={vodb} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('VOD Box') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'VOD Box', showmodels1: true }) }}>
        //                             Media Studio({this.getCountOfBoxType('VOD Box')})
        //                         </a>
        //                         {/* <a className="button" style={{marginRight: '15%', float: 'right'}}  data-toggle="modal" data-target="#hometheaterbox" onClick={(e)=>{this.getokaslist('VOD Box',buildingid,okasboxtypetoget)}} > {this.props.redux.globalVar.userTypeStyle==='2' ? '' :   <b><img src={Add}/></b>}</a> */}
        //                     </div>
        //                 </span>
        //                 {/* <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={uvodb} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('UVOD Box') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'UVOD Box', showmodels1: true }) }}>
        //                             Ultra Media Studio({this.getCountOfBoxType('UVOD Box')})
        //                         </a>
        //                     </div>
        //                 </span> */}
        //                 <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={ab} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('Audio Box') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Audio Box', showmodels1: true }) }}>
        //                             Music Studio({this.getCountOfBoxType('Audio Box')})
        //                         </a>
        //                         {/* <a className="button" style={{marginRight: '15%', float: 'right'}}  data-toggle="modal" data-target="#hometheaterbox" onClick={(e)=>{this.getokaslist('Audio Box',buildingid,okasboxtypetoget)}} > {this.props.redux.globalVar.userTypeStyle==='2' ? '' :   <b><img src={Add}/></b>}</a> */}
        //                     </div>
        //                 </span>
        //                 <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={mc} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('Control Studio') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Control Studio', showmodels1: true }) }}>
        //                             Control Studio({this.getCountOfBoxType('Control Studio')})
        //                         </a>
        //                     </div>
        //                 </span>
        //                 <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={ml} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: currentBuildingData[0].license_id.length === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Member License', showmodels1ML: true }) }}>
        //                             Member License({currentBuildingData[0].license_id.length})
        //                         </a>
        //                     </div>
        //                 </span>
        //                 <span>
        //                     <div className="">
        //                         <span className="icon-box-detail"><img src={ab} /></span>
        //                         <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('Core Okas') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Core Okas', showmodels1: true }) }}>
        //                             Core OKAS({this.getCountOfBoxType('Core Okas')})
        //                         </a>
        //                     </div>
        //                 </span>
        //             </span>
        //             : null}
        //         {/* {totbox5 > 0 ?
        //             <span>
        //                 <div className="">
        //                     <span className="icon-box-detail"><img src={uvodb} /></span>
        //                     <a data-toggle="modal" data-target="#configip" style={{ pointerEvents: this.getCountOfBoxType('Home Theatre Box') === 0 ? 'none' : '', paddingLeft: "5px" }} onClick={() => { this.setState({ currentConfigType: 'Home Theatre Box', showmodels1: true }) }}>
        //                         Home Theatre Box ({this.getCountOfBoxType('Home Theatre Box')})
        //                     </a>
        //                 </div>
        //             </span>
        //             : null} */}
        //     </span>

        // )

        return (
            <span>
                {(totbox1 > 0 || totbox7 > 0) ? (
                    <span>
                        {totbox1 > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={mc} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: this.getCountOfBoxType('Master Controller') === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'Master Controller', showmodels1: true }) }}>
                                    Master Studio ({this.getCountOfBoxType('Master Controller')})
                                </a>
                            </div>
                        )}

                        {totbox2 > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={vodb} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: this.getCountOfBoxType('VOD Box') === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'VOD Box', showmodels1: true }) }}>
                                    Media Studio ({this.getCountOfBoxType('VOD Box')})
                                </a>
                            </div>
                        )}

                        {totbox4 > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={ab} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: this.getCountOfBoxType('Audio Box') === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'Audio Box', showmodels1: true }) }}>
                                    Music Studio ({this.getCountOfBoxType('Audio Box')})
                                </a>
                            </div>
                        )}

                        {totbox6 > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={mc} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: this.getCountOfBoxType('Control Studio') === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'Control Studio', showmodels1: true }) }}>
                                    Control Studio ({this.getCountOfBoxType('Control Studio')})
                                </a>
                            </div>
                        )}

                        {currentBuildingData[0].license_id.length > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={ml} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: currentBuildingData[0].license_id.length === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'Member License', showmodels1ML: true }) }}>
                                    Member License ({currentBuildingData[0].license_id.length})
                                </a>
                            </div>
                        )}

                        {totbox7 > 0 && (
                            <div className="">
                                <span className="icon-box-detail"><img src={ab} /></span>
                                <a data-toggle="modal" data-target="#configip"
                                    style={{ pointerEvents: this.getCountOfBoxType('Core Okas') === 0 ? 'none' : '', paddingLeft: "5px" }}
                                    onClick={() => { this.setState({ currentConfigType: 'Core Okas', showmodels1: true }) }}>
                                    Core OKAS ({this.getCountOfBoxType('Core Okas')})
                                </a>
                            </div>
                        )}
                    </span>
                ) : null}
            </span>
        );


    }
    onAddClickHandler = (buttonaction, realtimebuildingid, realtimeokasboxtypetoget) => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        //console.log(TokenValue)
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')

        }
        let okasBox_id = realtimeokasboxtypetoget + ',' + this.state.okasboxid;
        //console.log(okasBox_id)
        let tt = { okasBox_id };
        if (buttonaction === 'add') {
            this.setState({
                disabledvalue: 'disabled',
            })

        }
        this.setState({
            loader: true,
        })
        fetch('/we/we/projectApi_detail/' + realtimebuildingid, {
            method: "PUT",
            headers: headers,
            body: JSON.stringify(tt)
        })
            .then(response => response.json())
            .then(data => {
                var dataadded = "dataadded";
                localStorage.setItem("dataadded", dataadded);
                if (buttonaction === 'add') {
                    // const history = createBrowserHistory({ forceRefresh: true });
                    window.location.href = '/projectdetail';
                }
            })
    }

    onHandoverClickHandler = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        const { pmId, buildingId, selectedSi, buildingName, projectManager } = this.state;
        const url = '/we/we/projectTransferRequest/';
        const payload = {

            pm_id: pmId,
            building_id: buildingId,
            email: selectedSi,
        };
        const requestBody = JSON.stringify(payload);

        // console.log( requestBody);

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: requestBody,
        })
            .then(response => {
                //  console.log('Response:', response);
                if (response.status === 200) {
                    this.setState({
                        showmodels: '',
                        showmodels2: true,
                    });

                    setTimeout(() => {
                        this.setState({ showmodels2: false });
                        window.location.reload();
                    }, 3000);
                }
                return response.json();  // This returns a promise
            })

            .then(data => {
                //  console.log('Success:', data.status);
                this.setState({
                    responseMessage: 'Handover successful!',
                    status: data.status,
                    projectName: data.building_name,
                    projectManagerName: data.assignee_pm_name,
                });
                // console.log(data.status)


            })
            .catch(error => {
                // console.error('Error:', error);
                this.setState({ responseMessage: 'Handover failed. Please try again.' });
            });
    }

    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }
        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }

    handleRadioSiChange = (emailId) => {
        // console.log(`Selected emailId: ${emailId}`);
        this.setState({
            selectedSi: emailId,
            si_id: emailId,
        });
    };

    renderTableData = (type) => {

        //console.log(this.state.okasBoxData)
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);
        let currentSi = this.state.siData; /////siData//////

        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }
        ///////////////////////////// Si data start ////////////////////////////////////////////
        if (type === 'siSelect') {
            var typee = 0;
            let xx = currentSi.map((e, index) => {
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className="config-table-pm">{e.first_name}</td>
                        <td className="config-table-pm">{e.email}</td>
                        <td className="config-table-pm">
                            <input
                                type="radio"
                                name={e.first_name}
                                checked={this.state.selectedSi === e.email}
                                onChange={() => this.handleRadioSiChange(e.email, e.id)}
                            />
                        </td>
                    </tr>
                )
            });
            //     return xx;
            // }


            // if (type === 'siSelect') {
            //     let xx = currentSi.map((e, index) => (
            //         <tr key={index}>
            //             <td className="config-table-pm">{e.first_name}</td>
            //             <td className="config-table-pm">{e.email}</td>
            //             <td className="config-table-pm">
            //                 {this.props.windowWidth > 760 ? (
            //                     <input
            //                         type="radio"
            //                         name={e.si_name}
            //                         checked={this.state.selectedSi === e.id}
            //                         onChange={() => this.handleRadioSiChange(e.id)}
            //                         value={e.id}
            //                     />
            //                 ) : (
            //                     <span className="input-checkbox-mobile">
            //                         <input
            //                             type="radio"
            //                             name={e.si_name}
            //                             checked={this.state.selectedSi === e.id}
            //                             onChange={() => this.handleRadioSiChange(e.id)}
            //                             value={e.id}
            //                         />
            //                     </span>
            //                 )}

            //             </td>

            //         </tr>
            //     ));

            // Optional: Add a message if there are no SI available
            if (currentSi.length === 0) {
                xx = (
                    <tr>
                        <td colSpan={3} className="text-center">
                            No project manager available
                        </td>
                    </tr>
                );
            }

            return xx;
        }

        /////////////////////////// Si Data end///////////////////////////
        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                //  console.log("eeeeeeeeeeeeeee", e);
                typee = typee + 1;
                let trrt = e.building_id;
                let dateconv = e.created_at;
                let okasboxnoofdatabase = e.okasBox_id;
                return (
                    <React.Fragment>
                        <tr>
                            <td className={this.props.windowWidth > 760 ? "padding-left-10px" : "qwerty"} style={{ maxWidth: '30px', textAlign: 'center', height: '55px' }} >
                                {this.state.rowOpenNumber === index && this.state.showRow ?
                                    <img src={Minus} style={{ cursor: 'pointer' }} onClick={(e) => {
                                        this.setState({
                                            rowOpenNumber: index,
                                            showRow: !this.state.showRow,
                                            currentBuildingSelected: trrt
                                        })
                                    }} />
                                    :
                                    <img src={Plus} style={{ cursor: 'pointer' }} onClick={(x) => {
                                        this.setState({
                                            rowOpenNumber: index,
                                            showRow: true,
                                            currentBuildingSelected: trrt,
                                            currentProjectBoxDetails: e.box_details
                                        })
                                    }} />
                                }
                            </td>
                            <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 1024 || this.props.windowWidth < 760 ? "" : "qwerty"} >{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                            <td style={{ textAlign: 'center' }} >{e.building_name}</td>
                            <td style={{ textAlign: 'center' }} >{e.owner_name}</td>
                            <td style={{ textAlign: 'center' }} >{e.address}</td>
                            <td style={{ textAlign: 'center' }} >{e.total_number_of_okas_box}</td>
                            <td style={{ textAlign: 'center' }} >{e.project_manager}</td>
                            {/* <td>{e.office_address}</td> */}
                            <td style={{ textAlign: 'center' }} >{dateconv.substring(0, 10)} {dateconv.substring(11, 19)}</td>
                            <td style={{ textAlign: 'center' }} >{e.subscription === "active" ? <span style={{ color: "green" }}>ACTIVE</span>
                                : e.subscription === "about_to_expire" ? <span style={{ color: "#FFD800" }}>ABOUT TO EXPIRE</span>
                                    : e.subscription === "expired" ? <span style={{ color: "red" }}>EXPIRED</span>
                                        : <span style={{ color: "grey" }}>NA</span>
                            }</td>
                            {/* {this.props.redux.globalVar.userTypeStyle==='1' ? */}
                            {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "edit") && <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 1024 || this.props.windowWidth < 760 ? "" : "qwerty"}><a
                                // to={{
                                //     pathname: "/projectdetailedit",
                                //     search: "?buildingid=" + e.building_id,
                                //     state: { fromDashboard: true }
                                // }}
                                href={`projectdetailedit/?buildingid=${e.building_id}`}
                            ><img src={Edit} />
                            </a></td>}
                            <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 1024 || this.props.windowWidth < 760 ? "" : "qwerty"}>

                                <img src={e.file === null ? downloadUnactive : e.file.length === 0 ? downloadUnactive : downloadActive} style={{ cursor: e.file === null ? 'not-allowed' : e.file.length === 0 ? 'not-allowed' : 'pointer' }}
                                    data-toggle={e.file === null ? 'dfs' : e.file.length === 0 ? 'tooltip' : 'dfs'} title={e.file === null ? '' : e.file.length === 0 ? "Project configuration is in progress" : ''} data-placement="left"
                                    onClick={() => {
                                        let TokenValue = 'Token ' + localStorage.getItem("auth");
                                        fetch(`/we/we/projectPdf/?building_id=${e.building_id}`, {
                                            method: "GET",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Authorization": TokenValue,
                                                'X-CSRFToken': localStorage.getItem('csrftoken')
                                            },
                                            // body: JSON.stringify({ building_id: e.building_id }) ,
                                        })
                                            .then(response => response.json())
                                            .then(data => {
                                                window.location.assign(data);
                                            })
                                        // console.log('test',this.state.data)
                                    }}
                                />
                            </td>
                            <td
                                style={{ display: this.props.windowWidth < 760 ? "" : "none", textAlign: 'center' }}
                                onClick={() => {
                                    this.setState({
                                        rowOpenNumber: index,
                                        showRow: true,
                                        currentBuildingSelected: trrt,
                                        currentProjectBoxDetails: e.box_details,
                                    }, () => {
                                        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
                                        this.setState({
                                            projectDetailMobileView: true
                                        })
                                    })
                                }
                                }
                            >View</td>



                            {this.state.userType === "1" && (
                                <td style={{textAlign:'center'}} className={this.props.windowWidth > 1024 || this.props.windowWidth < 760 ? "" : "qwerty"}>
                                    <a onClick={() => {
                                        this.onopenmodel(e.pm_id, e.building_id);
                                        this.getallrealdata(e.building_id);
                                    }}>
                                        <img src={ProjectDetailGray} alt="Project Detail" />
                                    </a>
                                </td>
                            )}

                            {this.state.userType === "4" &&
                                is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "edit") &&
                                is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "add") && (
                                    <td
                                        style={{ textAlign: 'center' }}
                                        className={this.props.windowWidth > 1024 || this.props.windowWidth < 760 ? "" : "qwerty"}
                                    >
                                        <a
                                            onClick={() => {
                                                this.onopenmodel(e.pm_id, e.building_id);
                                                this.getallrealdata(e.building_id);
                                            }}
                                        >
                                            <img src={ProjectDetailGray} alt="Project Detail" />
                                        </a>
                                    </td>
                                )}


                        </tr>
                        {this.state.rowOpenNumber === index && this.state.showRow ? <React.Fragment>
                            <td colspan="15" style={{ backgroundColor: "#F9F9F2", padding: "2%" }}>
                                <div className="row datasetleft" style={{ minHeight: "150px" }}>
                                    <div className="col-lg-4 col-md-4 col-sm-4 h-100 pdbox1" style={{ minHeight: "150px" }}>
                                        <b><span className="custom-font-partial-h"> Building Details</span> </b>
                                        <div className="">{/* Building ID -  */}{e.building_id}</div>
                                        <div className="senihading">{/* Building Name -  */}{e.building_name}</div>
                                        <div className="">{/* Building Address -  */}{e.address}</div>
                                        <br></br>
                                        <div className="senihading">{/* Owner Name -  */}{e.owner_name}</div>
                                        <div className=""> {/* Date -  */}{dateconv.substring(0, 10)} </div>
                                        <div className=""> {/* Time -  */}{dateconv.substring(11, 19)}</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 h-100 pdbox2" style={{ minHeight: "150px" }}>
                                        <b className="">
                                            <span className="custom-font-partial-h"> Project Manager Detail</span>
                                        </b>
                                        <div className="senihading">  {/*  Project Manager Name -  */}{e.project_manager}</div>
                                        <div className="">   {/* Project Manager Location -  */}{e.office_address}</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 h-100" style={{ minHeight: "150px" }}>
                                        <b className="">
                                            <span className="custom-font-partial-h">Okas Box Detail</span>
                                        </b>
                                        <div className="row ksdjfhsdk">
                                            {this.getokasnumber(okasboxnoofdatabase, e.building_id)}
                                            {/* <div className=""><a className="button"  data-toggle="modal" data-target="#hometheaterbox">Add More...</a></div> */}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </React.Fragment> : null}
                    </React.Fragment>
                )
            });
            return xx;
        }
        else if (type === 'type2') {
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_id === 123) {
                    return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{e.okasBox_id}</td>
                            <td>{e.okasBox_type}</td>
                            <td>{e.okasBox_serialNo}</td>
                            <td>{e.okasBox_version}</td>
                            <td>{e.okasBox_assigned_to}</td>
                        </tr>
                    )
                }
            });
            return xx1;
        }
    }


    onopenmodel = (pmId, buildingId, projectManager, buildingName) => {
        // Assuming you still want to toggle the background scroll stop

        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        // console.log('PM ID:', pmId, 'Building ID:', buildingId);
        // Simplified modal opening logic
        this.setState({
            showmodels: 'true',
            pagemode: '',
            modalTitle: 'Project Handover',
            pmId: pmId,
            buildingId: buildingId,
            projectManager: projectManager,
            buildingName: buildingName,


        });

        // Assuming you still want to deactivate the search bar
        this.props.searchBarActivate(false);
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
    }

    onAssignSiClosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            si_id: '',
            okasBox_id: [],
            id: '',
            memberLicenses: [],
            disableAddButton: false,
            selectedBoxes: [],
            selectedSi: '',
        })
    }



    onAddClickHandler = (buttonaction) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        }

        const { si_id, memberLicenses } = this.state;

        if (si_id && memberLicenses) {
            this.setState({
                disabledvalue: 'disabled',
                loader: true
            });

            let tt = {
                si_id: si_id,
                memberLicenses: memberLicenses,
            };

            fetch('/we/we/members_license/', {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    // console.log('Response from server:', data);
                    this.setState({
                        loader: false,
                        disabledvalue: ''
                    });

                    if (data.message === "success" && buttonaction === 'add') {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                        });
                        this.getallrealdata();
                        alert('Member Licence Successfully Assign To System Integrator!');
                        this.onAssignSiClosemodel();
                        this.errormsg();
                    } else {

                        alert('Unable to assign Member Licence to System Integrator!');
                        return null;
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.setState({
                        loader: false,
                        disabledvalue: ''
                    });
                    alert('An error occurred while processing the request.');
                });
        }
    }



    restoreData = (data) => {
        this.setState({
            // okasBoxData: data,
            memberLicenseData: data,

        })
    }

    restoreData = (data) => {
        this.setState({
            okasBoxData: data,

        })
    }
    sortingFunc = (type, searchValue) => {
        if (type !== "search") {
            this.props.searchBarActivate(false)
        }


        if (type == "building_id") {

            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
                rowOpenNumber: ''
            })
        }
        if (type == "building_name") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
                rowOpenNumber: ''
            })
        }
        if (type == "owner_name") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
                rowOpenNumber: ''
            })
        }
        if (type == "address") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusfo: !this.state.statusfo,
                rowOpenNumber: ''
            })
        }
        if (type == "total_number_of_okas_box") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusfi: !this.state.statusfi,
                rowOpenNumber: ''
            })
        }
        if (type == "project_manager") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statussi: !this.state.statussi,
                rowOpenNumber: ''
            })
        }
        if (type == "office_address") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusse: !this.state.statusse,
                rowOpenNumber: ''
            })
        }
        if (type == "created_at") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusei: !this.state.statusei,
                rowOpenNumber: ''

            })
        }
        if (type == "subscription") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusei: !this.state.statusei,
                rowOpenNumber: ''

            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasBoxData);
        } else if (type === 'search') {

            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata1, searchValue);
        } else {

            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasBoxData);
        }
    }


    onSearchClick = () => {
        this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    }

    configBoxDetail = (e) => {
        let boxType = this.state.currentConfigType;
        // console.log(this.state.okasBoxData)

        let boxes = [];
        this.state.okasBoxData?.forEach((innerElement) => {
            if (innerElement.building_id === this.state.currentBuildingSelected) {
                innerElement.box_details?.forEach((inner) => {
                    if (boxType === inner.okasBox_type) {
                        boxes.push(inner)
                    }
                })
            }
        })
        return boxes
    }

    getCountOfBoxType = (boxType) => {
        let count = 0;
        console.log(this.state.currentProjectBoxDetails)
        this.state.currentProjectBoxDetails?.forEach((e) => {

            if (e.okasBox_type === boxType) {
                count++
            }
            // console.log(count);
        })
        return count
    }

    renderProjectdetailsMobileView = (type) => {
        let projectDetails = this.state.okasBoxData.filter((e) => e.building_id === this.state.currentBuildingSelected)
        if (projectDetails.length !== 0) {
            return projectDetails[0][type]
        } {
            return "Not Known"
        }
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(2):before { content: "S.NO."; }
      td:nth-of-type(3):before { content: "PROJECT NAME"; }
      td:nth-of-type(4):before { content: "OWNER NAME"; }
      td:nth-of-type(5):before { content: "ADDRESS"; }
      td:nth-of-type(6):before { content: "BOXES"; }
      td:nth-of-type(7):before { content: "PROJECT MANAGER"; }
      td:nth-of-type(8):before { content: "INSTALLED D&T"; }
      td:nth-of-type(9):before { content: "Subscription"; }
      td:nth-of-type(10):before { content: "EDIT"; }
      td:nth-of-type(11):before { content: "DOWNLOAD"; }
      td:nth-of-type(12):before { content: "VIEW"; }
      td:nth-of-type(13):before { content: "SHARE"; }

      td.config-table:nth-of-type(1):before { content: "SERIAL NO."; }
      td.config-table:nth-of-type(2):before { content: "BOX VERSION"; }
      td.config-table:nth-of-type(3):before { content: "IPS"; }
      td.config-table:nth-of-type(4):before { content: " "; }
      td.config-table-ml:nth-of-type(1):before { content: "SERIAL NO."; }
      td.config-table-ml:nth-of-type(2):before { content: "MEMBER LICENSE"; }


      td.config-table-pm:nth-of-type(1):before{content:"Project Manager";}
      td.config-table-pm:nth-of-type(2):before{content:"Email";}
      td.config-table-pm:nth-of-type(3):before{content:"";}
    }`,
            <div>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                <div className="selfcontainer"
                    style={{
                        position: !this.props.redux.globalVar.backgroundScrollStop ? "fixed" : "absolute",
                        overflow: !this.props.redux.globalVar.backgroundScrollStop ? "hidden" : ""
                    }}

                >
                    {this.state.loader ? <Loader /> : null}
                    {this.props.redux.globalVar.searchBarShow ?
                        <div className='row searchinput'>
                            <SearchBar
                                autoFocus
                                value={this.state.searchValue}
                                onChange={(e) => {
                                    this.setState({
                                        searchValue: e
                                    }, () => {
                                        this.sortingFunc('search', this.state.searchValue)
                                    })
                                }
                                }
                                onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                                resetSearch={(e) => {
                                    this.setState({
                                        searchValue: e
                                    }, () => {
                                        this.sortingFunc('search', '')
                                    })
                                }}
                            />
                        </div>
                        : ''}



                    {/* Project manager Form start */}
                    {this.state.showmodels ?
                        <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                            <div className="selfmodal-dialog"
                                style={{
                                    width: this.props.windowWidth > 760 ? "50%" : "60%",

                                }}
                            >
                                <div className="selfmodal-content" style={{ marginTop: "100px" }}>
                                    <div className="modal-header" >
                                        <button type="submit" className="close" data-dismiss="modal"
                                            onClick={this.onAssignSiClosemodel.bind(this)}
                                        >&times;</button>
                                        <h3 className="modal-title">{this.state.modalTitle} </h3>
                                        <h6>Select a Project Manager to handover the project to</h6>
                                    </div>
                                    <div className="modal-body"  >
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small" className={"tablecontent"}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>Project Manager</strong></TableCell>
                                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>Email</strong></TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.renderTableData("siSelect")}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    <br />
                                    <div className="modal-footer">
                                        <React.Fragment>
                                            <button type="button"
                                                onClick={this.onAssignSiClosemodel.bind(this)}
                                                className="btn allbtn" data-dismiss="modal">
                                                Cancel
                                            </button>
                                            <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null}
                                                onClick={this.onHandoverClickHandler.bind(this, 'add')}
                                                className="btn btn-primary allbtn" data-dismiss="modal">
                                                Handover
                                            </button>
                                        </React.Fragment>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}

                    {/* Project manager Form End */}

                    {/* Project Manager form handover successfully start */}

                    {this.state.showmodels2 ?
                        <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                            alignItems: 'center', display: 'flex',
                            justifyContent: 'center',
                        }}>
                            <div className="selfmodal-dialog"
                                style={{
                                    width: this.props.windowWidth > 760 ? "50%" : "60%",
                                }}
                            >
                                <div className="selfmodal-content" style={{
                                    marginTop: "100px",
                                    display: 'flex',
                                    alignItems: 'center', // Center vertically
                                    justifyContent: 'center', // Center horizontally

                                }}>

                                    <div className="modal-header"  >


                                        {/* <h3 style={{ textAlign: 'center' }}>{this.state.projectName} has been handed over to {this.state.projectManagerName} successfully!</h3> */}
                                        <h3 style={{ textAlign: 'center' }}>
                                            {this.state.status === 401 ? (
                                                'Project Transfer request pending with other Project Manager !'
                                            ) : (

                                                `${this.state.projectName} has been handed over to ${this.state.projectManagerName} successfully!`
                                            )}
                                        </h3>
                                    </div>

                                </div>
                            </div>
                        </div>
                        : null}


                    {/* Project Manager form handover successfully end */}

                    {/* <div className="searchbar"> <Icon icon={search} />      Search Project Details</div> */}
                    {this.props.redux.globalVar.userTypeStyle === '2' ? '' :
                        <div className="addregOkasButton">
                            {/* <Link to="projectdetailadd">
                                <div className="addregOkasButtonicon button-custom-height-size">
                                    <AiOutlinePlus size={42} style={{ color: " #15599F" }} />
                                    <span className="hidden-xs hidden-sm button-color">ADD NEW PROJECT</span>

                                </div>
                            </Link> */}
                            {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "add") && <Box
                                component="a"
                                href="projectdetailadd"
                                className="addregOkasButtonicon button-custom-height-size"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#f9f9f9",
                                    color: "#94979a",
                                    textTransform: "none",
                                    padding: "10px 20px",
                                }}
                            >
                                <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                                <span className="hidden-xs hidden-sm button-color">ADD NEW PROJECT</span>
                            </Box>}
                            <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add New Project</div>
                        </div>
                    }
                    <div className='row'>
                        <h3>Dear {this.props.redux.globalVar.reUserNameStyle}, Listed below are the comprehensive details of each of your projects</h3>
                        <h6 className="mb-3 mt-0">To add a new project click on, "Add New Project" </h6>
                        <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                            <div className="inblksuccfull"><img src={Success} /></div>
                            <div className="inblksucc1">
                                SUCCESS !
                                <a className="successmsgcross">
                                    <RxCross2 style={{ color: 'white' }} size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} />
                                </a>
                            </div>
                        </div>
                        <div className="tests">
                            <TableContainer component={Paper}>
                                <Table className={"tablecontent2"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ textAlign: 'center' }}></TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px', textAlign: 'center' }}>
                                                <div className="align-vertical">S.No.</div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Project Name
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("building_name", "")}>
                                                        {this.props.statustw ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Owner Name
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("owner_name", "")}>
                                                        {this.props.statusth ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Address
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("address", "")}>
                                                        {this.props.statusfo ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Boxes
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("total_number_of_okas_box", "")}>
                                                        {this.props.statusfi ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Project Manager
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("project_manager", "")}>
                                                        {this.props.statussi ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Installed D&T
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("created_at", "")}>
                                                        {this.props.ei ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">
                                                    Subscription
                                                    <IconButton sx={{ color: "white" }} size="small" onClick={() => this.sortingFunc("subscription", "")}>
                                                        {this.props.ei ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            {(
                                                is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "edit") &&
                                                is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "project detail", "add")
                                            ) && (<TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">Edit</div>
                                            </TableCell>)}
                                            <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                <div className="align-vertical">Download</div>
                                            </TableCell>
                                            {this.state.userType === "4" && (
                                                
                                                <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                    <div className="align-vertical">Share</div>
                                                </TableCell>
                                            )}
                                             {this.state.userType === "1" && (
                                                
                                                <TableCell sx={{ color: "white", fontSize: '11px' }}>
                                                    <div className="align-vertical">Share</div>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{this.renderTableData("type1")}</TableBody>
                                </Table>
                            </TableContainer>
                            <div className="pull-right">
                                {this.state.todosPerPage < this.state.okasBoxData.length ?
                                    <ul className="pagination pull-right paginat">
                                        <li>
                                            <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasBoxData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasBoxData.length}  of {this.state.okasBoxData.length} enteries</span>
                                        </li>
                                        <li>
                                            <a
                                                style={{ pointerEvents: this.state.currentPage === 1 ? 'none' : '' }}
                                                onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                    this.handleClickpage.bind(this, this.state.currentPage - 1, 'position')
                                                }
                                                aria-label="Previous">
                                                <span aria-hidden="true">&laquo;</span>
                                                <span className="sr-only">Previous</span>
                                            </a>
                                        </li>

                                        {this.renderTableData('pagination')}
                                        <li className="">
                                            <a className=""
                                                style={{ pointerEvents: Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage) === Number(this.state.currentPage) ? 'none' : '' }}
                                                onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasBoxData.length ? null :
                                                    this.handleClickpage.bind(this, this.state.currentPage + 1, 'position')
                                                }

                                                aria-label="Next">
                                                <span aria-hidden="true">&raquo;</span>
                                                <span className="sr-only">Next</span>
                                            </a>
                                        </li>
                                    </ul>
                                    : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="hometheaterbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">{this.state.okasboxmodaletype}</h4>
                                </div>
                                <div className="modal-body">
                                    <TableContainer component={Paper} sx={{ borderRadius: "5px", overflowX: "auto" }}>
                                        <Table sx={{ minWidth: 650 }} size="small" className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell></TableCell> {/* Empty Column */}
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}><strong>BOX TYPE</strong></TableCell>
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}><strong>SERIAL NO.</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.someNewOne}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn allbtn" data-dismiss="modal" onClick={() => this.setState({ okasboxid: '', someNewOne: '', textvalue: [] })}>Cancel</button>
                                    <button type="submit" disabled={this.state.okasboxid === '' ? true : false} className="btn btn-primary allbtn"
                                        onClick={
                                            this.onAddClickHandler.bind(this, 'add', this.state.realtimebuildingid, this.state.realtimeokasboxtypetoget)
                                        }
                                    >Add</button>
                                    <input type="hidden" name="okasboxid" id="okasboxid" value={this.state.okasboxid} placeholder=""
                                        onChange={(e) => {
                                            this.setState({
                                                okasboxid: e.target.value
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showmodels1 ?
                    <div className="selfmodal fade modal-dialog-centered" id="configip" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{ zIndex: 1051 }}>
                        <div className="selfmodal-dialog"
                            style={{ width: this.props.windowWidth > 760 ? "50%" : "60%" }}
                        >
                            <div className="selfmodal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Config {this.state.currentConfigType === 'Master Controller' ? 'Master Studio'
                                        : this.state.currentConfigType === 'VOD Box' ? 'Media Studio'
                                            // : this.state.currentConfigType === 'UVOD Box' ? 'Ultra Media Studio'
                                            : this.state.currentConfigType === 'Audio Box' ? 'Music Studio'

                                                : this.state.currentConfigType}</h4>
                                </div>
                                <div className="modal-body">
                                    {/* <table
                                        className={this.props.windowWidth > 760 ? " table table-striped tablecontent tablecontentas" : "mobile-device-margin-zero"}
                                        style={{ borderRadius: '5px' }}>
                                        <thead>
                                            <tr>
                                                <th>SERIAL NO.</th>
                                                <th>BOX VERSION</th>
                                                <th>IPS</th>
                                                {this.props.redux.globalVar.userTypeStyle === '2' ? <th>CONFIG IP</th> : null}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.configBoxDetail().map((e) => {
                                                return (
                                                    <tr>
                                                        <td className="config-table">{e.okasBox_serialNo}</td>
                                                        <td className="config-table">{e.okasBox_version}</td>
                                                        <td className="config-table">
                                                            {'IP:' + e.ip}<br />{'SM:' + e.subnet_mask}<br />{'GW:' + e.gateway}
                                                        </td>
                                                        {this.props.redux.globalVar.userTypeStyle === '2' ? <td
                                                            className="config-table"
                                                        >
                                                            <a data-toggle="modal" data-target="#configForm" style={{ color: 'blue' }} onClick={() => { this.setState({ showmodels6: true, currentConfigType: this.state.currentConfigType, currentBoxSelected: e.okasBox_id, ipaddress: e.ip, subnetmask: e.subnet_mask, defaultgateway: e.gateway, }) }}>
                                                                Config
                                                            </a>
                                                        </td> : null}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table> */}
                                    <TableContainer component={Paper} sx={{ borderRadius: "5px", overflowX: "auto" }}>
                                        <Table sx={{ minWidth: 650 }} size="small" className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>SERIAL NO.</strong></TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>BOX VERSION</strong></TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>IPS</strong></TableCell>
                                                    {this.props.redux.globalVar.userTypeStyle === "2" && (
                                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>CONFIG IP</strong></TableCell>
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.configBoxDetail().map((e) => (
                                                    <TableRow key={e.okasBox_serialNo}>
                                                        <TableCell sx={{ fontSize: '12px' }}>{e.okasBox_serialNo}</TableCell>
                                                        <TableCell sx={{ fontSize: '12px' }}>{e.okasBox_version}</TableCell>
                                                        <TableCell sx={{ fontSize: '12px' }}>
                                                            IP: {e.ip} <br />
                                                            SM: {e.subnet_mask} <br />
                                                            GW: {e.gateway}
                                                        </TableCell>
                                                        {this.props.redux.globalVar.userTypeStyle === "2" && (
                                                            <TableCell sx={{ fontSize: '12px' }}>
                                                                <Link
                                                                    component="button"
                                                                    variant="body2"
                                                                    color="primary"
                                                                    onClick={() =>
                                                                        this.setState({
                                                                            showmodels6: true,
                                                                            currentConfigType: this.state.currentConfigType,
                                                                            currentBoxSelected: e.okasBox_id,
                                                                            ipaddress: e.ip,
                                                                            subnetmask: e.subnet_mask,
                                                                            defaultgateway: e.gateway,
                                                                        })
                                                                    }
                                                                >
                                                                    Config
                                                                </Link>
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <br />
                                <div className="modal-footer  align-btn-mobile">
                                    <button type="submit" data-dismiss="modal" onClick={() => { this.setState({ showmodels1: false }) }} className="btn allbtn">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                {/* start modals for member license */}

                {this.state.showmodels1ML ?
                    <div className="selfmodal fade modal-dialog-centered" id="configip" role="dialog" aria-hidden="true" style={{ zIndex: 1051 }} data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog" style={{ width: this.props.windowWidth > 760 ? "50%" : "60%" }}>
                            <div className="selfmodal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Member License</h4>
                                </div>
                                <div className="modal-body">
                                    <TableContainer component={Paper} sx={{ borderRadius: "5px" }}>
                                        <Table sx={{ minWidth: 650 }} size="small" className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>SERIAL NO.</strong></TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}><strong>Member License</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.okasBoxData
                                                    .filter((e) => e.building_id === this.state.currentBuildingSelected)[0]
                                                    ?.license_id.map((e, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{e}</TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <div className="modal-footer  align-btn-mobile">
                                    <button type="submit" data-dismiss="modal" onClick={() => { this.setState({ showmodels1ML: false }) }} className="btn allbtn">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                {/* end modals for member license */}

                {/*config modal start */}
                {this.state.showmodels6 ?
                    <div className="selfmodal fade modal-dialog-centered" id="configForm" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{ zIndex: 1052 }}
                    >
                        <div className="selfmodal-dialog" style={{ width: this.props.windowWidth > 760 ? "50%" : "60%", }}>
                            <form action="javascript:void(0)">
                                <div className="selfmodal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Config IP Form</h4>
                                    </div>
                                    {this.state.showError ? <div style={{ marginRight: '10px', marginLeft: '10px' }}>{!this.state.ipError ? <div className="alert alert-danger mx-2">IP error
                                    </div> : null}
                                        {!this.state.subnetError ? <div className="alert alert-danger mx-2">Subnet Error </div> : null}
                                        {!this.state.defaultError ? <div className="alert alert-danger mx-2">default Error</div> : null} </div> : null}
                                    {/* <div><b>Okas Box Number : </b>{this.state.pmid}</div> */}

                                    <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                                        <TextField
                                            label="IP Address"
                                            type="text"
                                            name="ipaddress"
                                            // placeholder="IP Address"
                                            value={this.state.ipaddress}
                                            onChange={(e) =>
                                                this.setState({
                                                    ipaddress: e.target.value,
                                                    showError: false
                                                }, () => console.log("Updated IP Address:", this.state.ipaddress))
                                            }
                                            fullWidth // ✅ Makes it responsive
                                            margin="normal" // ✅ Adds spacing
                                            variant="standard" // ✅ Modern UI
                                            error={this.state.showError} // ✅ Shows red outline if error exists
                                            helperText={this.state.showError ? "Invalid IP Address" : ""} // ✅ Displays error message
                                        />
                                        <br />
                                        <TextField
                                            label="Subnet Mask"
                                            type="text"
                                            name="subnetmask"
                                            // placeholder="Subnet Mask"
                                            value={this.state.subnetmask}
                                            onChange={(e) =>
                                                this.setState({
                                                    subnetmask: e.target.value,
                                                    showError: false
                                                })
                                            }
                                            fullWidth // ✅ Makes the input take up full width
                                            margin="normal" // ✅ Adds spacing
                                            variant="standard" // ✅ Modern UI
                                            error={this.state.showError} // ✅ Shows error when needed
                                            helperText={this.state.showError ? "Invalid Subnet Mask" : ""} // ✅ Displays error message
                                        />  <br />
                                        <TextField
                                            label="Default Gateway"
                                            type="text"
                                            name="defaultgateway"
                                            //placeholder="Default Gateway"
                                            value={this.state.defaultgateway}
                                            onChange={(e) =>
                                                this.setState({
                                                    defaultgateway: e.target.value,
                                                    showError: false
                                                })
                                            }
                                            fullWidth // ✅ Makes the input full-width
                                            margin="normal" // ✅ Adds spacing
                                            variant="standard" // ✅ Improves UI
                                            error={this.state.showError} // ✅ Shows error when needed
                                            helperText={this.state.showError ? "Please enter a valid Default Gateway" : ""} // ✅ Displays error message
                                        />  <br />
                                        <span className="fieldmend"></span>
                                    </div>
                                    <br />
                                    <div className="modal-footer  align-btn-mobile">
                                        <button type="button" className="btn allbtn" data-dismiss="modal" onClick={() => this.setState({
                                            ipaddress: '',
                                            showError: false,
                                            subnetmask: '',
                                            defaultgateway: '',
                                            showmodels6: false
                                        })} >Cancel</button>
                                        {/* <button type="submit" className="btn btn-primary allbtn" onClick={this.updateConfigIP.bind(this, 'add', this.state.currentBoxSelected)}>Update </button> */}
                                        <button
                                            type="submit"
                                            className="btn btn-primary allbtn"
                                            onClick={() => {
                                                this.updateConfigIP('add', this.state.currentBoxSelected);
                                                this.setState({ showmodels6: false });
                                            }}
                                        >
                                            Update
                                        </button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    : ''}
                {this.state.projectDetailMobileView ?
                    <div className="selfmodal fade in modal-dialog-centered" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "90%",
                            }}
                        >
                            <div className="selfmodal-content" style={{ backgroundColor: "#F9F9F2", padding: "2%" }} >
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal"
                                        onClick={(e) => {
                                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

                                            this.setState({
                                                rowOpenNumber: '',
                                                showRow: false,
                                                currentBuildingSelected: "",
                                                projectDetailMobileView: false
                                            })
                                        }}
                                    >&times;</button>
                                    <h4 className="modal-title">Project Details</h4>
                                </div>
                                <div className="modal-body modfields">
                                    <React.Fragment>
                                        {this.props.windowWidth < 760 ? <React.Fragment>
                                            <div style={{ backgroundColor: "#F9F9F2", padding: "2%" }}>
                                                <div className="row datasetleft">
                                                    <div className="col-xs-12 pdboxBottom p-2" >
                                                        <b>Building Details</b>
                                                        <div className="">{this.renderProjectdetailsMobileView('building_id')}</div>
                                                        <div className="senihading">{this.renderProjectdetailsMobileView('building_name')}</div>
                                                        <div className="">{this.renderProjectdetailsMobileView('address')}</div>
                                                        <br></br>
                                                        <div className="senihading">{this.renderProjectdetailsMobileView('owner_name')}</div>
                                                        <div className="">{this.renderProjectdetailsMobileView('created_at').substring(0, 10)} </div>
                                                        <div className="">{this.renderProjectdetailsMobileView('created_at').substring(11, 19)}</div>
                                                    </div>
                                                    <div className="col-xs-12 pdboxBottom" >
                                                        <b className="">Project Manager Detail</b>
                                                        <div className="senihading">{this.renderProjectdetailsMobileView('project_manager')}</div>
                                                        <div className="">{this.renderProjectdetailsMobileView('office_address')}</div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 col-sm-4 h-100">
                                                        <b className=""> Okas Box Detail </b>
                                                        <div className="row ksdjfhsdk">
                                                            {this.getokasnumber(this.renderProjectdetailsMobileView('okasBox_id'), this.renderProjectdetailsMobileView('building_id'))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment> : null}
                                    </React.Fragment>
                                </div>
                                <div className="modal-footer align-btn-mobile">
                                    <div type="button" className="btn allbtn"
                                        onClick={(e) => {
                                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

                                            this.setState({
                                                rowOpenNumber: '',
                                                showRow: false,
                                                currentBuildingSelected: "",
                                                projectDetailMobileView: false
                                            })
                                        }}
                                    >Close</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}


                {/*config modal end */}
            </div>


        );
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailPage);
